<template>
  <div class="sign-in">
    <div class="sign-banner" v-if="exhibitionInfo">
      <img :src="exhibitionInfo.exhibition.banner" />
      <div class="sign-logo">
        <img :src="exhibitionInfo.exhibition.logo" v-if="exhibitionInfo.exhibition.logo" />
        <img src="@/assets/img/empty.png" v-else />
      </div>
    </div>
    <div class="sign-form">
      <van-form @submit="onSubmit" label-width="1.85rem" class="reg_from" show-error :show-error-message="false">
        <van-field v-model="form.email" placeholder="E-mail" />
        <van-field v-model="form.password" placeholder="Password" type="password" />
        <div class="vant-btn">
          <van-button round block type="info" native-type="submit">
            Sign in
          </van-button>
        </div>
      </van-form>
      <p @click="linkToForgotPsw()">Forgot password?</p>
      <p>Don't have an account? <span @click="LinkToReg((opt = null))">Register</span></p>
      <div class="bottom">
        <p>Or quick access with</p>
        <div class="bottom-icon">
          <!-- <svg class="icon-svg" aria-hidden="true" @click="signinTwitter">
                        <use xlink:href="#icon-twitter"></use>
                    </svg>
                    <svg class="icon-svg" aria-hidden="true" @click="signinFacebook">
                        <use xlink:href="#icon-facebook"></use>
                    </svg> -->
          <svg class="icon-svg" aria-hidden="true" @click="signinLingying">
            <use xlink:href="#icon-lingying"></use>
          </svg>
          <!-- <svg class="icon-svg" aria-hidden="true" @click="signinWeibo">
                        <use xlink:href="#icon-weibo1"></use>
                    </svg> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "sign-in",
  data () {
    return {
      form: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      redirectUrl: "getRedirectUrl",
      talkRedirectUrl: "getTalkRedirectUrl",
    }),
  },
  methods: {
    ...mapMutations({
      setToken: "setToken",
      setExpiresIn: "setExpiresIn",
      setExhibitionId: "setExhibitionId",
      setRedirectUrl: "setRedirectUrl",
    }),
    ...mapActions({
      linkToForgotPsw: "linkTo/LinkToForgotPsw",
      login: "en/login",
      LinkToReg: "linkTo/LinkToReg",
      authenticateOidcWeibo: "oidcStoreWeibo/authenticateOidc",
      // authenticateOidcFacebook: "oidcStoreFacebook/authenticateOidc",
      // authenticateOidcTwitter: "oidcStoreTwitter/authenticateOidc",
      authenticateOidcLinkedIn: "oidcStoreLinkedIn/authenticateOidc",
    }),
    signinTwitter () {
      this.authenticateOidcTwitter();
    },
    signinFacebook () {
      this.authenticateOidcFacebook();
    },
    signinLingying () {
      this.authenticateOidcLinkedIn();
    },
    signinWeibo () {
      this.authenticateOidcWeibo();
    },
    async onSubmit () {
      if (!this.form.email || !this.form.password) {
        this.$toast.fail("The form cannot be empty");
        return;
      }
      let orgin = location.host.split(".").reverse()[1];
      let clientId = orgin === "zhanshangxiu" ? "synair-showonline-js" : `synair-${orgin}-js`;
      let opt = {
        client_id: clientId,
        client_secret: "synair-showonline-js",
        grant_type: "email",
        scope: "openid profile showonline-api bmm-api phone email address",
        email: this.form.email,
        password: this.form.password,
      };
      let res = await this.login(opt);
      console.log(res, "登录成功---");
      if (res) {
        // 请求token;
        localStorage.setItem("access_token", res.access_token);
        localStorage.setItem("expires_in", res.expires_at);
        this.setToken(res.access_token);
        this.setExpiresIn(res.expires_at);
        this.getMemberByToken(this.redirectUrl);
      } else {
        this.$toast.fail("Sign in failed");
      }
    },

    async getMemberByToken (path) {
      await this.$Myapollo.getUserInfoNoLogin(this);
      if (this.exhibitionId) {
        // await this.getExhibitionById(this.exhibitionId);
        await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId, "");
      }
      console.log(path, "当前保存的路径");
      if (path === "/auth" || path === "/" || path === "/custom-form") {
        let url = location.origin + "/home";
        let redirectUrl = this.redirectUrl ? location.origin + this.redirectUrl : "";
        this.$store.commit("setUrl", url);
        this.$store.commit("wxShare/setUrl", url);
        window.url = redirectUrl || url;
        console.log("!!!!!!!!!!!! 2-存入地址：", url);

        var myURL = new URL(redirectUrl || url);
        // this.$store.commit("setRedirectUrl", "");
        sessionStorage.setItem("login", "true");
        this.$router.replace(myURL.pathname + myURL.search);
        window.location.href = redirectUrl || url;
      } else {
        let pa = location.origin + path;
        let redirectUrl2 = this.redirectUrl ? location.origin + this.redirectUrl : "";
        this.$store.commit("setUrl", pa);
        this.$store.commit("wxShare/setUrl", pa);
        window.url = redirectUrl2 || pa;
        // this.$store.commit("setRedirectUrl", "");
        console.log("!!!!!!!!!!!! 3-存入地址：", pa);

        var myURL = new URL(redirectUrl2 || url);
        sessionStorage.setItem("login", "true");
        this.$router.replace(myURL.pathname + myURL.search);
        window.location.href = redirectUrl2 || pa;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sign {
  &-banner {
    width: 100%;
    height: 3.2rem;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .sign-logo {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -0.8rem;
      z-index: 1;
      margin: 0 auto;
      width: 1.6rem;
      height: 1.6rem;
      background-color: #fff;
      box-shadow: 0px 0.05rem 0.1rem 0px rgba(0, 0, 0, 0.2);
      border-radius: 0.1rem;
      img {
        border-radius: 0.1rem;
      }
    }
  }
  &-form {
    margin: 1.4rem 0.3rem 0;
    .vant-btn {
      margin-top: 0.5rem;
      span {
        font-size: 0.3rem;
      }
    }
    p {
      font-size: 0.24rem;
      color: #999;
      text-align: center;
      margin: 0.4rem 0;
      span {
        color: #0190fe;
      }
    }
    .bottom {
      margin-top: 0.7rem;
      margin: 0.7rem 1.3rem 0;
      &-icon {
        display: flex;
        // justify-content: space-between;
        justify-content: center;
        .icon-svg {
          font-size: 0.8rem;
        }
      }
    }
  }
}
</style>
